module.exports = __webpack_public_path__ + "static/media/edi.ec5c62b9.jpg";